import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { IndexPath } from '@/Config/app/router/index.path';
import { badgeVariants } from '@/Domain/components/Shared/Badge/Badge';
import { cn } from '@/Domain/utils/cn';

type Props = {
  className?: string;
  'data-testid'?: string;
};

/** Clickable "Upgrade plan to unlock" badge that links to the subscription page. */
export const UpgradeBadge = ({ className, 'data-testid': testId = 'upgrade-badge' }: Props) => {
  const { t } = useTranslation('common');
  const { scenario } = useParams<{ scenario?: string }>();
  const to = scenario ? `/i/${scenario}/${IndexPath.subscription}` : `../${IndexPath.subscription}`;

  return (
    <Link
      to={to}
      data-testid={testId}
      onClick={(e: MouseEvent) => e.stopPropagation()}
      className={cn(
        badgeVariants({ variant: 'secondary' }),
        'cursor-pointer transition-colors hover:border-transparent hover:bg-success-muted hover:text-success',
        'focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-0',
        className,
      )}
    >
      {t('upgrade_to_unlock')}
    </Link>
  );
};
